<template>
    <LRLayout>
        <LeftPanel :style="{ 'min-height': ztreeMinHeight + 'px', 'border-bottom': ztreeMinHeight ? '1px solid #d8dce5' : 'none' }" @node-click="handleNodeClick">
            <!-- <div class="searchType-content block-table-heder">
                <span class="title" :class="searchType === '0' ? 'active' : ''" @click="searchType = '0'">文件夹</span>
                <span class="title" :class="searchType === '1' ? 'active' : ''" @click="searchType = '1'">文件类型</span>
            </div> -->
            <!-- <div v-if="searchType === '0'" style="width:100%;margin: 14px 0px 10px 0;padding:0 10px" class="titleTop">
        <el-input v-model="searchkey" style="width:96%;margin:0 2%" placeholder="搜索文件夹" @keyup.enter.native="searchTreeNode">
          <el-button slot="append" icon="el-icon-search" @click="searchTreeNode" />
        </el-input>
      </div> -->
            <GiantTree ref="tree" :style="{ padding: '0 10px', height: 'calc(100% - 47px)', 'overflow-x': 'auto', 'min-height': ztreeMinHeight - 47 + 'px' }" node-key="id" :filter-node-method="filterNode" :nodes="treeData" @onCreated="onTreeCreated" @onClick="onTreeNodeClick" @onExpand="treeBeforeExpand">
                <template v-if="isPermissionsControl" #context-menu="slotProps">
                    <!-- <ul v-if="slotProps.contextNode.pId===null">
            <li @click="addModuleMenu(slotProps.treeId,slotProps.contextNode)">重命名</li>
          </ul> -->
                    <!-- <ul v-if="slotProps.contextNode.pId !== null">
                        <li @click="editMenu(slotProps.treeId, slotProps.contextNode, '重命名')">文件夹设置</li>
                        <li @click="editMenu(slotProps.treeId, slotProps.contextNode, '删除')">删除</li>
                        <li @click="editMenu(slotProps.treeId, slotProps.contextNode, '移动')">移动</li>
                    </ul> -->
                </template>
            </GiantTree>
            <!-- <div v-show="searchType === '1'" class="searchType1">
                <div v-for="i in flieTypeList" :key="i" class="type" @click="flieType = i.value">
                    <div :class="flieType === i.value ? 'type1 active1' : 'type1'">
                        <div>
                            <svg aria-hidden="true" class="svg_stile">
                                <use :xlink:href="i.icon" />
                            </svg>
                        </div>
                        <div>{{ i.name }}</div>
                    </div>
                </div>
            </div> -->
        </LeftPanel>
        <RightPanel style="overflow-y: auto;">
            <FileList v-if="treeNode != null" class="rightpanel" :type="type" :tree-node="treeNode" :search-type="searchType" :language="language" :map-list="mapList" :gdflsz-vos="gdflszVos" :flie-type="flieType" :root="root" :prefix-full-name="prefixFullName" :show-picture="showPicture" :current-dataid="currentDataid" />
        </RightPanel>
        <OrgTreeDialog />
        <el-button ref="gdTypeTree" v-model="contextNode.fullName" v-select-dialog="'gdtype'" class="selectFoder" style="display: none" readonly :init-tree-data="xztreeData" dialog-title="选择所属分组" :multiple="false" placeholder="请选择所属分类" name="" />
    </LRLayout>
</template>

<script>
import FileList from './components/FileList'
//import OrgTreeDialog from './components/OrgTreeDialog'
export default {
    components: {
        FileList
        // OrgTreeDialog
    },
    props: {},
    data() {
        return {
            showPicture: false,
            prefixFullName: '',
            defaultShowNodes: [],
            treeData: [],
            treeNode: null,
            searchType: '0', // 搜索条件
            loginUser: this.$store.getters.loginUser,
            root: {
                file: [{ id: '0', parentId: '0', name: '所有文件', categoryName: '所有文件', open: true, title: '所有文件' }],
                zjfile: [{ fullId: '0', id: '0', parentId: '0', name: '个人文件', folderName: '个人文件', open: true, title: '个人文件', fullName: '个人文件' }],
                time: [{ id: '1', name: '全部时间', year: '全部时间', open: true, title: '全部时间' }],
                type: [{ id: '1', name: '全部文种', categoryName: '全部文种', open: true, title: '全部文种' }]
            },
            zTree: null,
            language: [],
            searchkey: '', // 搜索字段
            flieTypeList: [
                {
                    name: '文档',
                    icon: '#icon-wjzx_wd',
                    value: 0
                },
                {
                    name: '图片',
                    icon: '#icon-wjzx_tp',
                    value: 1
                },
                {
                    name: '音频',
                    icon: '#icon-wjzx_yp',
                    value: 3
                },
                {
                    name: '视频',
                    icon: '#icon-wjzx_sp',
                    value: 2
                },
                {
                    name: '压缩包',
                    icon: '#icon-wjzx_ysb',
                    value: 4
                },

                {
                    name: '其他',
                    icon: '#icon-wjzx_qt',
                    value: 5
                }
            ],
            flieType: 0, // 文件类型
            type: 0, // 0个人  1部门  2公司
            dialogFormRename: false, // 文件夹重命名
            rename: '', // 重命名
            shareScope: 1,
            shareObjName: '',
            shareObjId: '',
            renameMoudlueInfo: {
                getByIdUrl: '/disk/folder/getById',
                listDataUrl: '/disk/folder/listdata',
                addNewUrl: '/disk/folder/addNew',
                insertUrl: '/disk/folder/insert',
                updateUrl: '/disk/folder/update',
                uploadUrl: '/disk/folder/upload',
                delUrl: '/disk/folder/delete'
            },
            contextNode: {}, // 选中的树
            selectType: 0, // 0移动文件夹 1移动文件
            selectFlderRow: [], // 选择移动的文件
            isPermissionsControl: false, // 不可编辑
            isCurrent: true, // true树重命名文件夹 false列表重命名文件夹
            oneTreenodes: '', // 树选择的当前节点
            ztreeMinHeight: 0,
            zt: 0,
            currentDataid: ''
        }
    },
    computed: {},
    watch: {
        searchType(val) {
            this.getTreeList()
        },
        filterText(val) {
            this.$refs.tree.filter(val)
        }
    },
    created() {
        // 从首页我的文件跳进来
        if (this.$route.query.selectType) {
            this.searchType = '1'
            this.flieType = Number(this.$route.query.selectType)
            const url = decodeURIComponent(location.href)
            const urlNew = url.split('?')[0]
            window.history.pushState(null, null, urlNew)
        }
        if (this.$route.meta.params === 'personal') {
            // 个人文件管理
            this.type = 0
            this.root.file = [
                { fullId: '1', id: '1', parentId: '1', name: '最近文件', folderName: '最近文件', open: true, title: '最近文件', fullName: '最近文件' },
                { fullId: '0', id: '0', parentId: '0', name: '个人文件', folderName: '个人文件', open: true, title: '个人文件', fullName: '个人文件' }
            ]
            this.root.zjfile = [{ fullId: '0', id: '0', parentId: '0', name: '个人文件', folderName: '个人文件', open: true, title: '个人文件', fullName: '个人文件' }]
        } else if (this.$route.meta.params === 'dept') {
            // 部门文件管理
            this.root.file = [{ fullId: '1', id: '1', parentId: '1', name: '最近文件', folderName: '最近文件', open: true, title: '最近文件', fullName: '最近文件' }]
            this.root.zjfile = [{ fullId: '0', id: '0', parentId: '0', name: '部门文件', folderName: '部门文件', open: true, title: '部门文件', fullName: '部门文件' }]
            this.type = 1
        } else if (this.$route.meta.params === 'company') {
            // 单位文件管理
            this.root.file = [
                { fullId: '1', id: '1', parentId: '1', name: '最近文件', folderName: '最近文件', open: true, title: '最近文件', fullName: '最近文件' },
                { fullId: '0', id: '0', parentId: '0', name: '单位文件', folderName: '单位文件', open: true, title: '单位文件', fullName: '单位文件' }
            ]
            this.root.zjfile = [{ fullId: '0', id: '0', parentId: '0', name: '单位文件', folderName: '单位文件', open: true, title: '单位文件', fullName: '单位文件' }]
            this.type = 2
        } else if (this.$route.query.prefixFullName == '人员资质') {
            //单位文件管理
            // this.root.file = [
            //     { fullId: '1', id: '1', parentId: '1', name: '最近文件', folderName: '最近文件', open: true, title: '最近文件', fullName: '最近文件' },
            //     { fullId: '0', id: '0', parentId: '0', name: '单位文件', folderName: '单位文件', open: true, title: '单位文件', fullName: '单位文件' }
            // ]
            // this.root.zjfile = [{ fullId: '1', id: '1', parentId: '1', name: '最近文件', folderName: '最近文件', open: true, title: '最近文件', fullName: '最近文件' }]
            this.type = 2
            this.prefixFullName = this.$route.query.prefixFullName
            this.showPicture = true
        }
        // 判断页面是否可编辑
        this.permissionsControl()
        this.getTreeList()
        // 刷新树
        this.$bus.$on('getTreeList', this.getTreeList)
        // 移动文件
        this.$bus.$on('mobile', this.mobile)
        // 编辑文件夹
        this.$bus.$on('editMenu', this.editMenu)
        // 列表联动树选择
        this.$bus.$on('listOnTreeNodeClick', this.listOnTreeNodeClick)
    },
    beforeDestroy() {
        this.$bus.$off('getTreeList', this.getTreeList)
        this.$bus.$off('mobile', this.mobile)
        // 编辑文件夹
        this.$bus.$off('editMenu', this.editMenu)
        // 列表联动树选择
        this.$bus.$off('listOnTreeNodeClick', this.listOnTreeNodeClick)
        // 获取子组件高度
        this.$bus.$off('setHeight', (res) => {
            this.ztreeMinHeight = res
        })
    },
    mounted() {
        // 获取子组件高度
        this.$bus.$on('setHeight', (res) => {
            this.ztreeMinHeight = res
        })
    },
    methods: {
        handleNodeClick(data) {
            debugger
            this.currentDataid = data.id
        },
        // 选择部门、科室、班组
        onSelectSuborgCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += ','
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this, 'shareObjId', selectCode)
            this.$set(this, 'shareObjName', selected)
        },
        // 选择工作群组
        onSelectWorkgroupCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selected += ','
                if (selected !== '') selectCode += '、'
                selected += node.name
                selectCode += node.id
            })
            this.$set(this, 'shareObjId', selectCode)
            this.$set(this, 'shareObjName', selected)
        },
        // 选择人员
        onSelectStaffCompleted(selectedNodes, attr) {
            let selected = ''
            let selectCode = ''
            selectedNodes.forEach(function (node) {
                if (selected !== '') selectCode += ','
                if (selected !== '') selected += '、'
                selected += node.name
                selectCode += node.personId
            })

            this.$set(this, 'shareObjId', selectCode)
            this.$set(this, 'shareObjName', selected)
        },
        // 权限控制
        permissionsControl() {
            if (this.type === 0) {
                this.isPermissionsControl = true
                return
            }
            this.$store.state.user.roles.forEach((res) => {
                if (res === 'wjzxDeptMgr' && this.type === 1) {
                    this.isPermissionsControl = true
                } else if (res === 'wjzxCompanyMgr' && this.type === 2) {
                    this.isPermissionsControl = true
                }
            })
        },
        // 移动文件
        mobile(a) {
            this.selectFlderRow = [...a]
            this.selectType = 1
            // document.querySelector('.selectFoder').click()
            // 代码模拟触发指令
            const el = {
                attrs: {
                    'dialog-title': '移动文件',
                    'init-tree-data': this.xztreeData
                }
            }
            const vnode = { context: this, data: { attrs: {}, model: { expression: 'vo.gdtype' } } }
            const binding = { value: 'gdtype' }
            this.$bus.emit('openOrgStaffSelectDialog1', el, binding, vnode)
        },
        // 重命名,删除,移动
        async editMenu(treeId, contextNode, type) {
            var treeObj = this.zTree // 获取树
            var treenodes = treeObj.getNodes() // 所在根节点
            var allTreenodes = treeObj.transformToArray(treenodes)
            if (allTreenodes.length > 0) {
                var number = 0
                allTreenodes.forEach((res, index) => {
                    if (res.id === contextNode.id) {
                        number = index
                    }
                })
            }
            this.oneTreenodes = allTreenodes[number]
            if (type === '重命名') {
                if (treeId === '文件夹') {
                    // 列表页面重命名文件夹
                    this.gdflszVos.forEach((i) => {
                        if (contextNode.id === i.id) {
                            this.contextNode = i
                            return
                        }
                    })
                    this.isCurrent = false
                } else {
                    this.isCurrent = true
                    // 树重命名文件夹
                    this.contextNode = { ...contextNode }
                }
                this.rename = this.contextNode.folderName
                if (this.contextNode.permissionType) {
                    this.shareScope = this.contextNode.permissionType
                }
                if (this.contextNode.passenger?.filePermission) {
                    this.shareObjId = this.contextNode.passenger.filePermission.permissionId
                    this.shareObjName = this.contextNode.passenger.filePermission.permissionName
                } else {
                    this.contextNode.passenger.filePermission = {}
                }
                this.dialogFormRename = true
                console.log(treeId, contextNode)
            } else if (type === '删除') {
                this.$confirm('您是否确认删除该文件夹？', '确认操作', { type: 'warning' })
                    .then(() => {
                        this.$http({
                            method: 'DELETE',
                            contentType: 'application/x-www-form-urlencoded',
                            params: { ids: contextNode.id },
                            url: this.renameMoudlueInfo.delUrl
                        }).then((res) => {
                            if (res.code === 'success') {
                                this.$message.success(res.message)
                                // 刷新树 获取父节点
                                this.getTreeList(this.oneTreenodes.getParentNode())
                                // 刷新选择的树
                                this.$bus.emit('selectTree')
                                // 刷新列表
                                this.$bus.emit('setListDataUrl')
                            } else {
                                this.$alert(res.message, { type: 'error' })
                            }
                        })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else if (type === '移动') {
                this.selectType = 0
                document.querySelector('.selectFoder').click()
                this.contextNode = { ...contextNode }
            }
        },
        // 移动
        async onGdtypeCompleted(selectedNodes, attr) {
            var _this = this
            // 移动文件夹
            if (!this.selectType) {
                var res = null
                this.contextNode.fullName = selectedNodes[0].name
                this.contextNode.parentId = selectedNodes[0].id === '0' ? null : selectedNodes[0].id
                res = await this.$app.update(this.renameMoudlueInfo.updateUrl, this.contextNode)
                if (res.code === 'success') {
                    _this.$message.success(res.message)
                    // 刷新树
                    _this.getTreeList()
                    // 刷新选择的树
                    _this.$bus.emit('selectTree')
                } else {
                    this.$message.error(res.message)
                }
            } else {
                /*
                if (selectedNodes) {
                    var array = this.selectFlderRow
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index]
                        // 把列表文件resoureType放到passenger里面
                        element.passenger.resoureType = element.resoureType
                        element.folderId = selectedNodes[0].id === '0' ? null : selectedNodes[0].id
                        await this.$http({
                            method: 'PUT',
                            url: '/disk/file/update',
                            data: element
                        }).then(res => {
                            if (res.code === 'success') {
                                if (index === array.length - 1) {
                                    this.$message.success(res.message)
                                    // 刷新树
                                    _this.getTreeList()
                                    // 刷新选择的树
                                    _this.$bus.emit('selectTree')
                                    this.$bus.emit('setListDataUrl')
                                }
                            } else {
                                this.$message.error(res.message)
                                return
                            }
                        })
                    }
                }
                */
                // 批量移动文件
                if (selectedNodes) {
                    var array = this.selectFlderRow
                    for (let index = 0; index < array.length; index++) {
                        const element = array[index]
                        element.folderId = selectedNodes[0].id === '0' ? null : selectedNodes[0].id
                    }
                    this.$http({
                        method: 'PUT',
                        url: '/disk/file/mobileFile',
                        data: array
                    }).then((res) => {
                        if (res.code === 'success') {
                            this.$message.success(res.message)
                            // 刷新树
                            _this.getTreeList()
                            // 刷新选择的树
                            _this.$bus.emit('selectTree')
                            // this.$bus.emit('setListDataUrl')
                        } else {
                            this.$message.error(res.message)
                            return
                        }
                    })
                }
            }
        },
        // 重命名
        async renameConfirm() {
            var _this = this
            var res = null
            this.formValidate(async () => {
                if (!this.rename) {
                    this.$alert('请输入名称', '提示', {
                        type: 'warning'
                    })
                    return
                }
                this.contextNode.name = this.contextNode.folderName = this.rename
                this.contextNode.permissionType = this.shareScope
                this.contextNode.passenger.filePermission.permissionId = this.shareObjId
                this.contextNode.passenger.filePermission.permissionName = this.shareObjName
                res = await this.$app.update(this.renameMoudlueInfo.updateUrl, this.contextNode)
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    _this.dialogFormRename = false
                    // 树重命名需要刷新 列表重命名不需要
                    if (this.isCurrent) {
                        // 刷新树
                        _this.getTreeList(this.oneTreenodes.getParentNode())
                        // 刷新选择的树
                        this.$bus.emit('selectTree')
                        // 刷新列表
                        // this.$bus.emit('setListDataUrl')
                    }
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        getNodeParentName(treeNode) {
            let pnode = treeNode.getParentNode()
            let pname = ''

            while (pnode !== null && pnode.getParentNode) {
                pname = pnode.name + '/' + pname
                pnode = pnode.getParentNode()
            }
            return pname === '' ? '/' : pname
        },
        // 搜索
        searchTreeNode() {
            this.getTreeList().then((res) => {
                var searchkey = this.searchkey
                if (!searchkey) {
                    searchkey = null
                }
                const nodeList = this.zTree.getNodesByParamFuzzy('name', searchkey)
                this.treeData = nodeList
            })
        },
        onTreeCreated(zTree) {
            console.log('url', location.href)
            let id = ''
            if (location.href.indexOf('?id=')) {
                id = location.href.split('?id=')[1]
            }
            this.zTree = zTree
            const treeObj = this.zTree // 获取树
            const treenodes = treeObj.getNodes() // 人员所在机构的树节点
            if (treenodes.length > 0) {
                this.$nextTick(() => {
                    if (id) {
                        if (treenodes[1].children.length > 0) {
                            treenodes[1].children.forEach((item, index) => {
                                if (item.id == id) {
                                    this.onTreeNodeClick('', treenodes[1].id, item) // 获取节点数据
                                    treeObj.selectNode(item) // 选中当前节点
                                } else {
                                    // this.onTreeNodeClick('', treenodes[1].id, treenodes[1].children[0])// 获取节点数据
                                    // treeObj.selectNode(treenodes[1].children[0])// 选中当前节点
                                }
                            })
                        } else {
                            this.onTreeNodeClick('', treenodes[1].id, treenodes[1].children[0]) // 获取节点数据
                            treeObj.selectNode(treenodes[1].children[0]) // 选中当前节点
                        }
                    } else {
                        if (this.prefixFullName) {
                            this.onTreeNodeClick('', treenodes[0].id, treenodes[0]) // 获取节点数据
                            treeObj.selectNode(treenodes[0]) // 选中当前节点
                        } else {
                            this.onTreeNodeClick('', treenodes[1].id, treenodes[1]) // 获取节点数据
                            treeObj.selectNode(treenodes[1]) // 选中当前节点
                        }
                    }
                })
            }
        },
        onTreeNodeClick(evt, treeId, treeNode) {
            console.log(treeNode, 'treeNode1')
            this.treeNode = treeNode
        },
        listOnTreeNodeClick(row) {
            if (!row) {
                return
            }
            const treeObj = this.zTree // 获取树
            const treenodes = treeObj.getNodes() // 获取所在根节点
            const allTreenodes = treeObj.transformToArray(treenodes) // 获取所有节点
            if (allTreenodes.length > 0) {
                let number = 0
                allTreenodes.forEach((res, index) => {
                    if (res.id === row.id) {
                        number = index
                    }
                })
                this.$nextTick(() => {
                    this.onTreeNodeClick('', allTreenodes[number].id, allTreenodes[number]) // 获取节点数据
                    treeObj.selectNode(allTreenodes[number]) // 选中当前节点
                    treeObj.expandNode(allTreenodes[number], true, false, true) // 展开当前节点 //第二个参数表示只展开当前节点不包含子孙节点
                })
            }
        },
        async getTreeList(treeNode) {
            // 加载类型节点数据
            await this.$http({
                method: 'GET',
                contentType: 'application/x-www-form-urlencoded',
                // data: [{ compare: '=', field: 'orgCode', merge: true, value: this.loginUser.orgCode }],
                // params: {
                //     type: this.type,
                //     prefixFullName: this.prefixFullName
                // },
                url: '/dagl/xmzlFolder/getFolderByProjectId?id=' + this.$route.query.voId
            }).then((res) => {
                if (res.code === 'success') {
                    this.language = res.body.language
                    this.gdflszVos = res.body.diskFolders
                    this.mapList = res.body.mapList
                    if (!this.prefixFullName) {
                        this.treeData = this.treeDataAdapter(this.root.file.concat(res.body.diskFolders))
                        this.xztreeData = this.treeDataAdapter(this.root.zjfile.concat(res.body.diskFolders))
                    } else {
                        this.treeData = this.treeDataAdapter(res.body.diskFolders)
                        this.xztreeData = this.treeDataAdapter(res.body.diskFolders)
                    }
                    return this.treeData
                } else {
                    this.$alert(res.message, '操作提示', { type: 'error' })
                }
            })
            this.$nextTick(() => {
                this.listOnTreeNodeClick(treeNode)
            })
        },
        treeDataAdapter(treeData) {
            treeData.forEach((node) => {
                if (!node.parentId) {
                    node.pId = '0'
                    node.open = true
                } else {
                    node.pId = node.parentId
                }
                node.title = node.name = node.folderName
                // 默认展开节点
                // node.open = true
            })
            // treeData格式必须遵循ztreeview treeNode规范
            return treeData
        }
    }
}
</script>

<style scoped lang="scss">
$lw: 3px;
.searchType-content {
    height: 43px;
    font-size: 14px;
    text-align: center;
    border-bottom: 1px solid #d8dce5;
    .title {
        display: inline-block;
        font-size: var(--portalFontSize13);
        line-height: 43px-$lw;
        padding: 0 15px;
        cursor: pointer;
        &.active {
            color: #409eff;
            border-bottom: $lw solid #409eff;
        }
    }
}
.searchType1 {
    .type {
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        font-size: var(--portalFontSize14);
        // border-bottom: 1px solid #EBEEF5;
        .type1 {
            display: flex;
            color: #333333;
            padding-left: 10px;
            height: 40px;
            line-height: 40px;
            width: 90%;
            margin: 11px auto;
            border-radius: 4px;
        }
    }
}
.ztree-container {
    height: calc(100vh - 208px);
}
.svg_stile {
    width: 13px;
    height: 13px;
    position: relative;
    top: 1px;
    margin: 0 10px;
}
.active1 {
    color: #409eff;
    background-color: #f3f4f4;
}
.titleTop {
    /deep/.el-input__inner {
        height: 28px !important;
        font-size: var(--portalFontSize12);
    }
}
//  /deep/.el-col-14{
//     width: 30%!important;
// }
// /deep/.el-col-10{
//     width: 70%!important;
// }
.app-container.lrlayout .panel-right {
    height: calc(100vh - 50px - 60px - 22px - 20px);
}
</style>
